import React from 'react';
import classNames from 'classnames';
import { Link } from '@/components/shared';
import { DrawerMegaMenuItem } from '@/types/drawerMegaMenuItem';
import styles from './MenuDropdown.module.scss';

interface MenuDropdownProps {
	items: DrawerMegaMenuItem[];
	showDropdown?: boolean;
	ariaControlId: string;
}

export const MenuDropdown: React.FunctionComponent<MenuDropdownProps> = ({ items, showDropdown, ariaControlId }) => {
	return (
		<ul className={styles.dropdownList} aria-hidden={!showDropdown} id={ariaControlId} role={'menu'}>
			{items.map((item, index) => (
				<li key={index} className={styles.mainItem}>
					<Link
						className={classNames(styles.level2Link, {
							[styles.hasChildren]: item.children && item.children.length > 0,
						})}
						to={item.internalLink}
						linkUrl={item.externalLink}
						weight={'bold'}
						textLink
						tabIndex={!showDropdown ? -1 : undefined}
						target={item.externalLink ? '_blank' : undefined}
						role={'menuitem'}
						hideExternalIcon
					>
						{item.name}
					</Link>

					{item.children && (
						<ul className={styles.level3List} role={'menu'}>
							{item.children.map((subItem, subIndex) => (
								<li key={subIndex}>
									<Link
										className={styles.level3Link}
										to={subItem.internalLink ? subItem.internalLink : undefined}
										linkUrl={subItem.externalLink ? subItem.externalLink : undefined}
										textLink
										tabIndex={!showDropdown ? -1 : undefined}
										target={subItem.externalLink ? '_blank' : undefined}
										role={'menuitem'}
										hideExternalIcon
									>
										{subItem.name}
									</Link>
								</li>
							))}
						</ul>
					)}
				</li>
			))}
		</ul>
	);
};
